import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';

import {setShowApiErrorModal} from '../../actions/Api';

const defaultProps = {
    setShowApiErrorModal: isShowErrorModal => {
    }
};

class ApiErrorModal extends Component {
    constructor(props){
        super(props);

        this.hideModal = this.hideModal.bind(this);
        this.formBody = this.formBody.bind(this);
    }
    hideModal = () => {
        this.props.setShowApiErrorModal(false);
    };


    formBody(exceptionCode, message) {
        let {i18n} = this.props
        if (exceptionCode == null) {
            return message
        }

        switch (exceptionCode) {
            case 'UserNotFillProfileException':
                return (<div>{i18n['creatingObjectPage.needFillProfile']} <a
                    href={"/crm/profile"} target='_blank'>{i18n['crm.menu.user.profile']}</a>!</div>);
            default:
                return message;

        }
    }

    render() {
        const {
            api: {
                message,
                exceptionCode,
                isShowErrorModal
            }
        } = this.props;

        return (
            <ReactModal
                isOpen={isShowErrorModal}
                className="custom-react-modal"
                overlayClassName="custom-react-modal-overlay"
            >
                {this.formBody(exceptionCode, message)}

                <br/><br/>

                <button onClick={this.hideModal} className="btn btn-border">
                    Close
                </button>
            </ReactModal>
        );
    }
}

ApiErrorModal.defaultProps = defaultProps;

const mapStateToProps = state => ({
    api: state.api,
    i18n: state.languages.i18n
});

const mapDispatchToProps = {
    setShowApiErrorModal
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiErrorModal);



// WEBPACK FOOTER //
// ./src/components/Base/ApiErrorModal.js